(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('chamadosApp')
        .constant('VERSION', "1.17.0")
        .constant('DEBUG_INFO_ENABLED', false)
;
})();
